export const environment = {
  // ==========================================
  // CONFIGURACIÓN GENERAL
  // ==========================================
  production: true,
  environment: 'PRODUCTION',

  // ==========================================
  // URL DE API - SERVICIOS PRINCIPALES
  // ==========================================
  WS_CONSULTA_USUARIOS: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/WS_ConsultaUsuarios',
  CREAR_USUARIO: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/WS_CrearUsuario',
  WS_CONSULTA_ROL_USUARIO: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/WS_ConsultaRolUsuario',
  WSCreaEliminaUser: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/WSCreaEliminaUser',
  WS_ACTUALIZAR_USUARIO: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/WSActualizarUsuario',

  // ==========================================
  // CLAVE DE SUSCRIPCIÓN UNIFICADA
  // ==========================================
  subscriptionKey: 'abd3e1503fef4420ab715c8d221d8a51',

  subscriptionKeyConsultaUsuarios: 'abd3e1503fef4420ab715c8d221d8a51',
  subscriptionKeyRetornaDatosPersona: 'abd3e1503fef4420ab715c8d221d8a51',
  subscriptionKeyGAM: 'abd3e1503fef4420ab715c8d221d8a51',

  // ==========================================
  // URLs DE API - SERVICIOS PRINCIPALES
  // ==========================================
  apiUrl: 'https://apimaz.grupokaufmann.com/prd/v1/gam/Retorna-Datos-GAM/',
  apiClientesMovilidad: 'https://apimaz.grupokaufmann.com/prd/crm/cliente/v1/movilidad',
  apiUrlAplicaciones: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/WSObtenerGAMApplications',
  retornaDatosCuentaCRMSet: 'https://apimaz.grupokaufmann.com/prd/crm/cliente/v1/movilidad/RETORNA_DATOS_CUENTA_CRMSet',
  apiUrlAplicacionesGam: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios',
  
  // ==========================================
  // URLs DE API - SERVICIOS ESPECÍFICOS
  // ==========================================
  retornaDatosPersona: 'https://apimaz.grupokaufmann.com/prd/crm/cliente/v1/movilidad/RETORNA_DATOS_PERSONASet',
  login: 'https://apimaz.grupokaufmann.com/prd/genexus/gam/v1/servicios/login',
  cuentas: 'https://apimaz.grupokaufmann.com/prd/v1/gam/Retorna-Datos-GAM/',

  // ==========================================
  // CONFIGURACIÓN DE API
  // ==========================================
  api: {
    login: 'abd3e1503fef4420ab715c8d221d8a51',
    cuentas: 'abd3e1503fef4420ab715c8d221d8a51',
  },

  // ==========================================
  // CONFIGURACIÓN SAP
  // ==========================================
  sap: {
    appServer: 'sapappserver',
    clientNumber: '100',
    routerString: '/H/saprouter1/H/',
    systemId: 'PRD',
    instanceNumber: '00',
    sessionName: 'SAP',
    userName: 'sapuser',
    password: 'sappassword'
  },


   // ==========================================
  // URLs EXTERNAS
  // ==========================================
  registroUrl: 'https://registrousuarios.kaufmann.cl/validar', 
  recuperarContraseñaUrl: 'https://registrousuarios.kaufmann.cl/recuperar',

  // ==========================================
  // CONFIGURACIÓN DE DOMINIOS
  // ==========================================
  domains: {
    'localhost': {
      logo: 'assets/images/kaufmann-logo.jpg',
      theme: {
        primary: '#000000'
      },
      prefijo: 'CL'
    },
    'default': {
      logo: 'assets/images/kaufmann-logo.jpg',
      theme: {
        primary: '#000000'
      },
      prefijo: 'CL'
    }
  }
};
